  import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@node_modules/@angular/material";

@Component({
  selector: 'app-trial-students',
  templateUrl: './trial-students.component.html',
  styleUrls: ['./trial-students.component.scss']
})
export class TrialStudentsComponent implements OnInit {
  static modalRef;
  students = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.students = this.data.trialStudents;
  }

  close() {
    TrialStudentsComponent.modalRef.close();
  }
}
